import { Flex } from "@/components/atoms/flex";
import { MenuListPopover } from "@/components/atoms/menuList";
import {
	MenuGroupHeader,
	MenuDivider,
	Button,
	Text,
	MenuItemRadio,
	mergeClasses,
} from "@fluentui/react-components";
import { ChevronDown20Regular } from "@fluentui/react-icons";
import { useStyle } from "./style";
import { useCallback, useMemo } from "react";
import { SelectItemProps, SelectProps } from "./types";

export const Select = (props: SelectProps) => {
	const {
		selectedKey,
		items,
		onSelect,
		listHeader,
		unselectedMessage,
		disabled,
	} = props;

	const SelectedMenuKey = "SelectedKey";
	const classes = useStyle();
	const mappedItems = useMemo<JSX.Element[]>(() => {
		const mapped = items.map((item: SelectItemProps) => (
			<MenuItemRadio
				key={item.key}
				name={SelectedMenuKey}
				value={item.key}
				className={classes.filterCheckboxItem}
				children={
					<div style={{ display: "flex", flexDirection: "column" }}>
						<span className={classes.itemElipsis}>{item.queueName}</span>
						<span className={classes.itemElipsis}>{item.name}</span>
					</div>
				}
				disabled={item.isDisabledExceptUnify && !item.data.acsResourceId}
				title={`${item.queueName} ${item.name}`}
			/>
		));

		return !!listHeader
			? [
					<MenuGroupHeader key="selectHeader" children={listHeader} />,
					<MenuDivider key="headerDivider" />,
					...mapped,
				]
			: mapped;
	}, [items, onSelect, listHeader]);

	const onCheckedValueChangeCallback = useCallback(
		(_e: any, data: { checkedItems: string[] }) => {
			const selectedItem = items.find((x) => data.checkedItems.includes(x.key));
			!!selectedItem && onSelect(selectedItem);
		},
		[items, onSelect]
	);

	const selectedQueueMessage =
		items.find((x: SelectItemProps) => x.key === selectedKey)?.queueName ||
		unselectedMessage;

	const selectedMessage =
		items.find((x: SelectItemProps) => x.key === selectedKey)?.name ||
		unselectedMessage;

	return (
		<MenuListPopover
			positioning={{
				position: "below",
				align: "end",
				offset: { crossAxis: 20, mainAxis: 15 },
			}}
			items={mappedItems}
			onCheckedValueChange={onCheckedValueChangeCallback}
			checkedValues={{ [SelectedMenuKey]: [selectedKey] }}
			classesName={{
				container: props.classNames?.container ?? "",
				menuPopoverOutbound: props.classNames?.menuPopoverOutbound,
			}}
			trigger={
				<Button
					className={mergeClasses(
						classes.dropdownTrigger,
						props.classNames?.trigger
					)}
					icon={<ChevronDown20Regular />}
					iconPosition="after"
					appearance="transparent"
					disabled={disabled}
				>
					<Flex
						column
						className={mergeClasses(
							classes.triggerRoot,
							props.classNames?.trigger
						)}
					>
						<Text
							wrap={false}
							size={200}
							truncate
							className={mergeClasses(
								classes.triggerText,
								!selectedKey ? classes.missing : undefined
							)}
							title={selectedQueueMessage}
							children={selectedQueueMessage}
						/>
						{selectedKey && (
							<Text
								wrap={false}
								size={200}
								truncate
								className={mergeClasses(
									classes.triggerText,
									!selectedKey ? classes.missing : undefined
								)}
								title={selectedMessage}
								children={selectedMessage}
							/>
						)}
					</Flex>
				</Button>
			}
		/>
	);
};
